export default __webpack_public_path__ + "static/media/c3.cf1300dc.png";